module.exports = __webpack_public_path__ + "static/media/school_people.69d14062.svg";